type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const MetaIcon = ({
    width =20,
    height=20,
    fill="none"
}: Props) =>{
    return (
<svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 5.92486 18.0751 1 12 1C5.92486 1 1 5.92486 1 12C1 17.4904 5.02254 22.0412 10.2812 22.8663V15.1797H7.48828V12H10.2812V9.57656C10.2812 6.81969 11.9235 5.29688 14.4361 5.29688C15.6396 5.29688 16.8984 5.51172 16.8984 5.51172V8.21875H15.5114C14.1449 8.21875 13.7188 9.06667 13.7188 9.93658V12H16.7695L16.2818 15.1797H13.7188V22.8663C18.9775 22.0412 23 17.4904 23 12Z" fill="#1877F2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.2818 15.1797L16.7695 12H13.7188V9.93658C13.7188 9.06667 14.1449 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.6396 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8663C10.8413 22.9542 11.4153 23 12 23C12.5847 23 13.1587 22.9542 13.7188 22.8663V15.1797H16.2818Z" fill="white"/>
</svg>


    )
}

export default MetaIcon;